import { IAttachment,
         AttachmentTypeEnum }            from '.';


/**
 * Define attachment entity associated Button type.
 */
export class AttachmentButtonEntity implements IAttachment {
    public attId!: string;
    public type!: AttachmentTypeEnum;
    public alreadyClicked!: boolean;

    /**
     * Constructor
     * 
     * @param id - The associated button unique id
     * @param key - The associated button key information 
     * @param text - The button text
     * @param finalMessage - The message to display to the user after button clicked
     * @param watermark - The associated message watermark
     * @param buttonCSS - The list of CSS classes to set to the button component
     */
    constructor(public  id: string,
                public  key: string,
                public  text: string,
                public  watermark?: number,
                public  finalMessage?: string,
                public  buttonCSS?: string) {

                    this.alreadyClicked = false;
                    this.type = AttachmentTypeEnum.BUTTON;
                    this.attId = `btn-${this.id}`;
                }
}
